module.exports = __webpack_public_path__ + "static/media/logoManow.61c96262.png";